module.exports = __webpack_public_path__ + "components/flag/static/square/sm-d0241a287219d5c3e788695a7fd8570a.svg";